import { URL_REGEX } from "Utilities/helpers";
import * as yup from "yup";

export const useNameAndUrlStepValidationSchema = () => {
  return yup.object().shape({
    name: yup.string().required("Name is required").notOneOf([""], "Name cannot be empty"),
    url: yup.string().matches(URL_REGEX, "Enter valid URL!").required("Url is required"),
  });
};
